// Range of the text anomaly chart.
export const CHART_HOURS_BEFORE_ANOMALY = 120;
export const CHART_HOURS_AFTER_ANOMALY = 72;
